import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useFavoriteTicketsStore } from "../favorite-tickets-store";
import { storeToRefs } from "pinia";
import { watch, onMounted } from "vue";
import FavoriteTicketsSlider from "../components/favorite-tickets-slider.vue";


export default /*@__PURE__*/_defineComponent({
  __name: '_favorite-tickets',
  setup(__props) {

const store = useFavoriteTicketsStore();
const { favoriteTickets } = storeToRefs(store);

const updateWidgetVisibility = () => {
    const widgetElement = document.getElementById("cp-favorite-tickets");
    if (widgetElement) {
        if (favoriteTickets.value.length === 0) {
            widgetElement.style.display = "none";
        } else {
            widgetElement.style.display = "";
        }
    }
};

watch(
    favoriteTickets,
    () => {
        updateWidgetVisibility();
    },
    { immediate: true }
);

onMounted(() => {
    updateWidgetVisibility();
});

return (_ctx: any,_cache: any) => {
  return (_unref(favoriteTickets).length)
    ? (_openBlock(), _createBlock(FavoriteTicketsSlider, {
        key: 0,
        favoriteTickets: _unref(favoriteTickets)
      }, null, 8, ["favoriteTickets"]))
    : _createCommentVNode("", true)
}
}

})